<!-- <p fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start start" fxLayoutAlign.xs="start start" *ngIf="value == 0 || value">
  <strong [ngClass.xs]="'small-screen'" fxFlex="30">{{label}}</strong>
  <span fxFlex="50">{{value}}</span>
</p> -->

<!-- <p class="row" *ngIf="value == 0 || value">
  <strong [ngClass.xs]="'small-screen'" class="col-sm-4 col-md-4 col-lg-4">{{label}}</strong>
  <span class="col-sm-8 col-md-8 col-lg-8 text-center">{{value}}</span>
</p> -->

<div class="container">
  <div class="row py-8px">
    <!-- Stack below 768px; original side-by-side split from tablet up. -->
    <div class="col-12 col-md-4">
      <strong><label>{{label}}</label></strong>
    </div>
    <div class="col-12 col-md-5">
      <span>{{value}}</span>
    </div>
  </div>
</div>

